import React, { useState } from "react";
import {
  validateInput,
  VALIDATOR_TYPE_REQUIRE,
  VALIDATOR_TYPE_EMAIL,
  VALIDATOR_TYPE_HAS_NUMBER,
  VALIDATOR_TYPE_MINLENGTH,
} from "../../common/utility/validation";

const Footer = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState({});
  const [contact, setContactData] = useState({
    senderName: "",
    email: "",
    message: "",
  });
  const [showMessgae, setShowMessage] = useState(false);

  const validator = {
    senderName: [
      { type: VALIDATOR_TYPE_REQUIRE },
      { type: VALIDATOR_TYPE_HAS_NUMBER },
    ],
    email: [{ type: VALIDATOR_TYPE_REQUIRE }, { type: VALIDATOR_TYPE_EMAIL }],
    message: [
      { type: VALIDATOR_TYPE_REQUIRE },
      { type: VALIDATOR_TYPE_MINLENGTH, val: 50 },
    ],
  };

  const onChangeHandler = (event) => {
    event.preventDefault();
    const { id, value } = event.target;
    setContactData((prevState) => ({
      ...prevState,
      [id]: value,
    }));

    setError((prevError) => ({
      ...prevError,
      [id]: "",
    }));
  };

  const submitForm = async (event) => {
    event.preventDefault();

    let formIsValid = true;
    const errors = {};

    // Validate each field
    Object.keys(validator).forEach((field) => {
      const validationRules = validator[field];
      const value = contact[field];

      validationRules.forEach((rule) => {
        const { isValid, errorMessage } = validateInput(value || "", rule);
        if (!isValid) {
          formIsValid = false;
          if (!errors[field]) {
            errors[field] = errorMessage; // Add error message to the field
          }
        }
      });
    });

    if (!formIsValid) {
      setError(errors); // Set error state to show messages
      setSuccessMessage("Please correct the highlighted errors.");
      return; // Stop submission if the form is invalid
    }

    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_KEY + "contact/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: contact.senderName,
          email: contact.email,
          message: contact.message,
        }),
      });

      if (!response.ok) {
        setSuccessMessage("Error! not able to save the data.");
        throw new Error("Error! not able to save the data.");
      }

      setSuccessMessage(
        "Thank you for reaching out! I'll get back to you soon."
      );
      setShowMessage(true);

      setContactData({
        senderName: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div
        className={`snackbar ${showMessgae ? "showMessage" : "hideMessage"}`}
      >
        {successMessage}{" "}
        <span className="closeBtn" onClick={() => setShowMessage(false)}>
          X
        </span>
      </div>
      <section className="footer-style-one space-y-top-65" id="contact">
        <div className="container">
          <div className="footer-content">
            <div className="row gy-4 gx-4">
              <div className="col-lg-6">
                <h2 className="footer__title">
                  LET'S GET <br /> IN TOUCH
                </h2>
                <ul className="social">
                  <li>
                    <a target="_blank" href="https://www.linkedin.com/in/simran-singh-39949a110/">
                      <i className="bi bi-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:ssingh.khalsa7@gmail.com">
                      <i className="bi bi-briefcase"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <form onSubmit={submitForm}>
                  <div className="row gy-4">
                    <div className="col-lg-6">
                      <div className="contact_input">
                        <input
                          type="text"
                          id="senderName"
                          placeholder="Your Name"
                          onChange={onChangeHandler}
                          data-iserror={!!error?.senderName}
                          value={contact.senderName}
                        />
                        <span className="error">{error?.senderName || ""}</span>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="contact_input">
                        <input
                          type="email"
                          id="email"
                          placeholder="Your Email"
                          onChange={onChangeHandler}
                          data-iserror={!!error?.email}
                          value={contact.email}
                        />
                        <span className="error">{error?.email || ""}</span>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="contact_input">
                        <textarea
                          cols="20"
                          rows="5"
                          placeholder="Your Message"
                          id="message"
                          onChange={onChangeHandler}
                          data-iserror={!!error?.message}
                          value={contact.message}
                        ></textarea>
                        <span className="error">{error?.message || ""}</span>
                      </div>
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="btn-border-border text-white text-start d-inline-block"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
